import axios from "axios";
import { API_BASE_URL } from "../utils/constant";
import { queryClient } from "../utils/queryClient";
import { logApiError } from "../utils/errorLogger";

const axiosAPI = axios.create({
  // baseURL: `${API_BASE_URL}/api`,
  baseURL: `${API_BASE_URL}`,
  headers: {
    "Content-type": "application/json",
  },
});

axiosAPI.interceptors.request.use(
  (config) => {
    const requestUrl = String(config.url || "");
    const skipAuth = requestUrl.includes("/get-form-json");
    const token = localStorage.getItem("token");
    if (token && !skipAuth) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const formDetails = queryClient.getQueryData(["formDetails"]);
    const { isOtpDisabled } = formDetails || {};
    if (error.response && error.response.status === 401) {
      const requestUrl = String(error.config?.url || "");
      if (requestUrl.includes("/get-form-json")) {
        return Promise.reject(error);
      }
      const token = localStorage.getItem("token");

      if (!token && isOtpDisabled === true) {
        return Promise.reject(error);
      }
      // Token is expired or invalid - clear state and redirect
      localStorage.clear();
      window.location.href = "/";
    }
    const status = error.response?.status;
    if (!error.response || status >= 500) {
      logApiError(error, error.config?.url, {
        method: error.config?.method,
      });
    }
    return Promise.reject(error);
  }
);

export default axiosAPI;
